import React, { useMemo } from "react"
import Link from "../../utils/link"

const TeamCard = ({ acf, title, slug, teamDetails, profile, className }) => {
  const phoneNumbers = useMemo(() => {
    const phone1 = acf.contactNumber ?? teamDetails.mobile
    const phone2 = teamDetails?.phone

    return phone1 && !phone2 ? [null, phone1] : [phone1, phone2]
  }, [teamDetails?.phone, acf.contactNumber, teamDetails.mobile])
  return (
    <div className={`team ${className}`.trim()}>
      <div className="team__content">
        {acf?.thumbnailImage && (
          <div className="team__image">
            {!profile && (
              <Link to={`/team/${slug}/`}>
                <img
                  loading="lazy"
                  src={acf.thumbnailImage?.sourceUrl}
                  alt={title}
                />
              </Link>
            )}
            {profile && (
              <img
                loading="lazy"
                src={acf.thumbnailImage?.sourceUrl}
                alt={title}
              />
            )}
          </div>
        )}

        <div className="team__details">
          <div className="general-detail">
            <h4>
              {teamDetails?.firstName}
              <br /> {teamDetails?.lastName}
            </h4>

            {teamDetails?.jobTitle && <p>{teamDetails.jobTitle}</p>}

            {acf.companyName && (
              <p className="general-detail-company">{acf.companyName}</p>
            )}
          </div>

          <div className="contact-detail">
            {phoneNumbers?.map((phn, index) => (
              <p className={phn ? "" : "phone-number-placeholder"} key={index}>
                {phn ? (
                  <Link to={`tel:${phn}`}>{phn}</Link>
                ) : (
                  <>
                    <span></span>
                  </>
                )}
              </p>
            ))}

            {teamDetails?.email && (
              <p className="email">
                <Link to={`mailto:${teamDetails.email}`}>Email</Link>
              </p>
            )}
          </div>

          {!profile && (
            <div className="team__link">
              <Link to={`/team/${slug}/`} className="btn">
                Profile
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default TeamCard
